__turbopack_context__.v({
  "action": "empty-state-module__9TuPeG__action",
  "body": "empty-state-module__9TuPeG__body",
  "headline": "empty-state-module__9TuPeG__headline",
  "icon": "empty-state-module__9TuPeG__icon",
  "root": "empty-state-module__9TuPeG__root",
});
